import { DeductionsStoreType } from '../composables/useSymbolDeductions';

type CalcValueParamsType = {
  quantity?: number | null;
  price?: number | null;
};

type CalcQuantityParamsType = {
  totalValue?: number | null;
  price?: number | null;
};

function calcSymbolSellValue(
  { quantity, price }: CalcValueParamsType,
  wage: DeductionsStoreType
): number {
  if (quantity && price) {
    return quantity * price * (1 - wage.sellValue);
  }

  return 0;
}

function calcSymbolBuyValue(
  { quantity, price }: CalcValueParamsType,
  wage: DeductionsStoreType
): number {
  if (quantity && price) {
    return quantity * price * (1 + wage.buyValue);
  }

  return 0;
}

function calcSymbolQuantitySell(
  { totalValue, price }: CalcQuantityParamsType,
  wage: DeductionsStoreType,
  roundUp = false
): number {
  if (totalValue && price) {
    const quantity = totalValue / (price * (1 - wage.sellValue));

    return roundUp ? Math.floor(quantity) : Math.ceil(quantity);
  }

  return 0;
}

function calcSymbolQuantityBuy(
  { totalValue, price }: CalcQuantityParamsType,
  wage: DeductionsStoreType,
  roundUp = false
): number {
  if (totalValue && price) {
    const quantity = totalValue / (price * (1 + wage.buyValue));

    return roundUp ? Math.floor(quantity) : Math.ceil(quantity);
  }

  return 0;
}

function calcSymbolBreakPointPrice(
  netAveragePrice: number,
  netAverageDps: number,
  wage: DeductionsStoreType
): number {
  return (
    (netAverageDps + netAveragePrice * wage.buyValue) / (1 - wage.sellValue)
  );
}

function calcIndividualDensity({
  individualVolume,
  individualCount,
  closingPrice,
}: {
  individualVolume: number;
  individualCount: number;
  closingPrice: number;
}): number {
  return (individualVolume / individualCount) * closingPrice || 0;
}

function calcIncomingIndividualMoney({
  buyIndividualVolume,
  sellIndividualVolume,
  closingPrice,
}: {
  buyIndividualVolume: number;
  sellIndividualVolume: number;
  closingPrice: number;
}): number {
  return (buyIndividualVolume - sellIndividualVolume) * closingPrice;
}

function calcBubbleOfInvestmentFunds({
  lastTradePrice,
  priceOfNav,
}: {
  lastTradePrice: number | null;
  priceOfNav: number | null;
}): number {
  if (lastTradePrice && priceOfNav) {
    return (lastTradePrice / priceOfNav - 1) * 100;
  }

  return 0;
}

export {
  calcSymbolSellValue,
  calcSymbolBuyValue,
  calcSymbolQuantitySell,
  calcSymbolQuantityBuy,
  calcSymbolBreakPointPrice,
  calcIndividualDensity,
  calcIncomingIndividualMoney,
  calcBubbleOfInvestmentFunds,
};
